export const MAX_ALLOWED_TABLE_VALUES = {
    rows: 7,
    cols: 7,
}